import React from "react";
import { Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Input } from "reactstrap";
import { getAdminHeadersInfo } from "../../redux/actions/dashboard";
import { useLocation, useRoutes } from "react-router-dom";

const PageContainer = (props) => {
  const { pathname } = useLocation();
  return (
    <TransitionGroup>
      <CSSTransition
        component="div"
        classNames="TabsAnimation"
        appear={true}
        timeout={1500}
        enter={false}
        exit={false}
      >
        <div className="admin-box">
          {/* <Container fluid> */}
          {/* <div className="app-page-title">
            <div className="page-title-wrapper">
              <div className="page-title-heading">
                <div className="page-title-icon">
                  <i className={props.pageTitleIcon} />
                </div>
                <div>
                  {props.pageHeading}
                  <div className="page-title-subheading">
                    {props.pageSubTitle}
                  </div>
                </div>
              </div>
              <div className="page-title-right">
                <span>Choose a Date</span>
                <Input
                  value={props.date}
                  onChange={(e) => props.setDate(e.target.value)}
                  type="date"
                  placeholder="Today"
                />
              </div>
            </div>
          </div> */}
          <div className="app-title d-md-flex align-items-md-center">
            <div className="flex-grow-1 d-flex align-items-center mb-2 mb-md-0">
              <span className="avatar">
                <i
                  className={props.pageTitleIcon}
                  style={{ height: "2rem", width: "2rem" }}
                />
              </span>
              <div>
                <h3 className="m-0 mb-1">{props.pageHeading}</h3>
                <span className="d-block">{props.pageSubTitle}</span>
              </div>
            </div>
            {(pathname === "/dashboard" && (
              <div className="flex-shrink-0 ms-md-3 d-md-flex align-items-md-center">
                <label className="weight-500 me-md-2 mb-2 mb-md-0 text-nowrap">
                  Choose a Date
                </label>
                <div className="position-relative">
                  <Input
                    className="w-100 w-md-auto"
                    value={props.date}
                    onChange={(e) => props.setDate(e.target.value)}
                    type="date"
                    placeholder="Today"
                  />
                </div>
              </div>
            )) ||
              null}
          </div>
          {/* </Container> */}
          {props.children}
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default PageContainer;
